<div class="popup-search" *ngIf="DisplayMode==2">
    <input type="text" (focus)="showSearchbox()" [disabled]="isDisabled" />
    <form [formGroup]="dataForm" class="data-form">
        <ngx-smart-modal #modal identifier="myModal" customClass="'modal'">
            <h4 class="modal-title">{{modalTitle}}</h4>
            Hello This is test Popup
            <input type="text" placeholder="{{placeholderText}}" formControlName="data">
            <table>
                <thead>
                    <tr>
                        <td>Product Name</td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of $filteredData | async">
                        <td>
                            {{item.Name}}
                        </td>
                    </tr>
                </tbody>
            </table>

        </ngx-smart-modal>
    </form>
</div>

<div class="autocomplete-search" *ngIf="DisplayMode==1">
  <form [formGroup]="dataForm" class="data-form">
    <mat-form-field class="select-data">
      <input type="text" #dataInput [disabled]="isDisabled" (keydown)="valuechange($event)" placeholder="{{placeholderText}}" matInput formControlName="data" [matAutocomplete]="auto" (blur)="panelClosed($event)">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)='itemSelected($event)'>
        <mat-option *ngFor="let item of $filteredData | async" [value]="item">
          {{item.Name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>
</div>

<div class="dropdown-search" *ngIf="DisplayMode==3">
    Dropdown
</div>

<!--{{EnumDataFor[dataFor]}}-->
